import {
  Box,
  Flex,
  IconButton,
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import { DeleteIcon, EditIcon, SearchIcon } from "@chakra-ui/icons";
import Layout from "../components/Layout";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import client from "../utils/client";
import { format } from "date-fns";
import AdminPage from "../components/AdminPage";

const AllBlog = () => {
  const [posts, setPosts] = useState([]);
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const auth = useAuth();
  const navigate = useNavigate();

  const isAdmin = auth?.user?.type === process.env.REACT_APP_ADMINISTRATOR;
  const isBlogAuthor = auth?.user?.type === process.env.REACT_APP_BLOG;

  const handleDelete = async (postId) => {
    if (!window.confirm("Confirmar exclusão desta publicação?")) return;
    await client.delete(`/blog/${postId}`);
    setPosts((prev) => prev.filter((p) => p.postId !== postId));
  };

  useEffect(() => {
    setIsLoadingPage(true);
    client
      .get("/blog?page=1")
      .then((res) => {
        let items = res.data.postItems || [];
        if (isBlogAuthor && !isAdmin) {
          items = items.filter((p) => p.authorId === auth.user.id);
        }
        setPosts(items);
      })
      .finally(() => setIsLoadingPage(false));
  }, [isAdmin, isBlogAuthor, auth.user.id]);

  return (
    <Layout>
      <AdminPage
        title={isAdmin ? "Gerenciar Blog" : "Minhas Publicações"}
        subtitle={`${posts.length} ${posts.length === 1 ? "publicação" : "publicações"}`}
        action={() => navigate("/createBlog")}
        actionLabel="+ Nova Publicação"
      >
        <Skeleton isLoaded={!isLoadingPage}>
          <TableContainer>
            <Table size="sm" variant="striped" colorScheme="green" fontSize="0.82rem">
              <Thead bg="green.50">
                <Tr>
                  <Th fontSize="0.72rem" maxW="220px">Título</Th>
                  <Th fontSize="0.72rem">Data</Th>
                  <Th fontSize="0.72rem">Autor</Th>
                  <Th fontSize="0.72rem">Ações</Th>
                </Tr>
              </Thead>
              <Tbody>
                {posts.length === 0 && !isLoadingPage && (
                  <Tr>
                    <Td colSpan={4}>
                      <Box textAlign="center" py={8} color="gray.400">
                        <Text>Nenhuma publicação encontrada.</Text>
                      </Box>
                    </Td>
                  </Tr>
                )}
                {posts.map((post) => {
                  const isOwner = post.authorId === auth.user.id;
                  const canEdit = isAdmin || isOwner;
                  const canDelete = isAdmin || isOwner;
                  return (
                    <Tr key={post.postId}>
                      <Td maxW="220px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" title={post.title} fontSize="0.82rem">
                        {post.title}
                      </Td>
                      <Td fontSize="0.82rem" whiteSpace="nowrap">
                        {format(new Date(post.createdAt), "dd/MM/yyyy")}
                      </Td>
                      <Td maxW="140px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" fontSize="0.82rem">
                        {post.authorName}
                      </Td>
                      <Td>
                        <Flex gap={2}>
                          <Tooltip label="Ver publicação">
                            <IconButton
                              colorScheme="green"
                              variant="ghost"
                              size="xs"
                              icon={<SearchIcon />}
                              onClick={() => navigate(`/blog/${post.postId}`)}
                            />
                          </Tooltip>
                          {canEdit && (
                            <Tooltip label="Editar">
                              <IconButton
                                colorScheme="orange"
                                variant="ghost"
                                size="xs"
                                icon={<EditIcon />}
                                onClick={() => navigate(`/createBlog/${post.postId}`)}
                              />
                            </Tooltip>
                          )}
                          {canDelete && (
                            <Tooltip label="Excluir">
                              <IconButton
                                colorScheme="red"
                                variant="ghost"
                                size="xs"
                                icon={<DeleteIcon />}
                                onClick={() => handleDelete(post.postId)}
                              />
                            </Tooltip>
                          )}
                        </Flex>
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </Skeleton>
      </AdminPage>
    </Layout>
  );
};

export default AllBlog;
